/**
 * 採用エントリーの項目（フォームの name 属性）と、項目ごとの検証ルール。
 *
 * サーバ側（app/Controllers/Recruit.php の validationRules() と AppController の $_*_rule）と同じ内容にする。
 */
export const ENTRY_FIELDS = ["name", "birthday_yyyy", "tel", "email", "job_career"] as const;

export type EntryField = typeof ENTRY_FIELDS[number];

export type EntryInput = Record<EntryField, string>;

/**
 * 検証ルールの名前（サーバ側のルール名と同じ）
 */
export type EntryRuleName =
    | "required"
    | "max_length"
    | "valid_email"
    | "valid_birthday"
    | "valid_tel"
    | "no_control_chars"
    | "single_line";

export type EntryRule = {
    readonly name: EntryRuleName;
    readonly param?: number;
};

export type EntryFieldDefinition = {
    readonly label: string;
    readonly rules: readonly EntryRule[];
};

export const ENTRY_FIELD_DEFINITIONS: Readonly<Record<EntryField, EntryFieldDefinition>> = {
    name: {
        label: "お名前",
        rules: [{name: "required"}, {name: "max_length", param: 50}, {name: "single_line"}],
    },
    birthday_yyyy: {
        label: "生年月日",
        rules: [{name: "required"}, {name: "valid_birthday"}],
    },
    tel: {
        label: "連絡先電話番号",
        rules: [{name: "required"}, {name: "max_length", param: 20}, {name: "valid_tel"}],
    },
    email: {
        label: "連絡先メールアドレス",
        rules: [{name: "required"}, {name: "max_length", param: 254}, {name: "valid_email"}, {name: "single_line"}],
    },
    job_career: {
        label: "自由記入欄",
        rules: [{name: "max_length", param: 2000}, {name: "no_control_chars"}],
    },
};
